import {EntityWithId} from "../../types/baseEntities";

export enum SolicitudPreviewEventos {
  Creada = 'Creada',
  Editada = 'Editada',
  Enviada = 'Enviada',
  Propuesta = 'Nueva propuesta',
  PropuestaAceptada = 'Propuesta aceptada',
  NuevoEvento = 'Nuevo evento'
}

export enum SolicitudPreviewEstados {
  EnAprobacion = 1,
  Instrumentada = 2,
  NoAcordada = 3,
  PendienteMonetizacion = 4,
  Pendiente = 5,
  Anulada = 6,
  Analisis = 7,
  DesistidaPorBanco = 8,
  PendienteEnvio = 9,
  Desistida = 10,
  Cancelada = 11,
  Rechazada = 12,
  PendienteAprobacion = 13,
  Aprobada = 14
}

export type TipoSolicitudPreview = {
  id: number
  empresaId: number
  montoSolicitado: number
  nombre: string
  destino: string
  estado: SolicitudPreviewEstados
  fechaAlta: string
  fechaEdicion?: string
  notificacion: boolean
  fechaEnvio?: string
  historia: EventoSolicitud[]
}

export type EventoSolicitud = {
  quien: 'usuario' | 'fogaba'
  cuando: string
  que: string
  evento: SolicitudPreviewEventos
  descripcion: string
}

export enum CamposGarantiaSolicitud {
  Monto = 'monto',
  Banco = 'banco',
  Plazo = 'plazo',
  Tna = 'tna'
}

export interface GarantiaSolicitud extends EntityWithId<number>{
  [CamposGarantiaSolicitud.Monto]: number,
  [CamposGarantiaSolicitud.Banco]: string,
  [CamposGarantiaSolicitud.Plazo]: string,
  [CamposGarantiaSolicitud.Tna]: number
} 